import ApiService from "../../../ApiService";

const DetailsService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/loadscreenview", { id }, successCallback, failureCallback);
    },
    loadMoreReply: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/loadmorereply", vo, successCallback, failureCallback);
    },
    loadMoreLike: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/loadmorelike", vo, successCallback, failureCallback);
    },
    addReply: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/addreply", vo, successCallback, failureCallback);
    },
    deleteReply: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/deletereply", vo, successCallback, failureCallback);
    },
    deleteBbs: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/deletebbs", vo, successCallback, failureCallback);
    },
    addLike: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/addlike", vo, successCallback, failureCallback);
    },
    deleteLike: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/removelike", vo, successCallback, failureCallback);
    },
    addSticky: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/addsticky", vo, successCallback, failureCallback);
    },
    deleteSticky: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/deletesticky", vo, successCallback, failureCallback);
    },
    addDigest: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/adddigest", vo, successCallback, failureCallback);
    },
    deleteDigest: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/details/deletedigest", vo, successCallback, failureCallback);
    },
    uploadPhoto: (file, postId, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "BbsReplies");
        formData.append("field", "Data");
        formData.append("postId", postId);
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    }
};

export default DetailsService;